module.exports = __webpack_public_path__ + "bb4aff78288083a46e5c074bdedfc637.png";